import {
  parseBooleanFromQuery,
  parseFilterArrayFromQuery,
  parseSearchFromQuery,
  parseTableOptionsFromQuery,
} from '@/utils/listRouteState'

const listNavigationFlag = { list_navigation: '1' }

const tableDefaults = () => ({
  sortDesc: [true],
  page: 1,
  itemsPerPage: 10,
  sortBy: [],
})

/**
 * Mirrors getEmployees params for detail GET with list_navigation=1.
 */
export function buildEmployeeListNavigationParams(routeQuery) {
  const options = parseTableOptionsFromQuery(routeQuery, tableDefaults())
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('fullName', 'candidate__user__last_name')
      .replace('phoneNumber', 'candidate__user__phone')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    ...listNavigationFlag,
    candidate__tags: parseFilterArrayFromQuery(routeQuery, 'tags'),
    status: parseFilterArrayFromQuery(routeQuery, 'status'),
    languages: parseFilterArrayFromQuery(routeQuery, 'languages'),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}

/**
 * Mirrors getHouses params.
 */
export function buildHouseListNavigationParams(routeQuery) {
  const hideFull = parseBooleanFromQuery(routeQuery, 'hideFullHouses', false)
  const options = parseTableOptionsFromQuery(routeQuery, tableDefaults())
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('roomCounter', 'room_counter')
      .replace('freeSeats', 'free_seats')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    ...listNavigationFlag,
    status: parseFilterArrayFromQuery(routeQuery, 'status'),
    tags: parseFilterArrayFromQuery(routeQuery, 'tags'),
    ...(hideFull ? { hide_full_houses: true } : {}),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}

/**
 * Mirrors getClients params.
 */
export function buildClientListNavigationParams(routeQuery) {
  const options = parseTableOptionsFromQuery(routeQuery, tableDefaults())
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('projectsAmount', 'projects_amount')
      .replace('positionsAmount', 'positions_amount')
      .replace('projectsWorkload', 'projects_workload')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    ...listNavigationFlag,
    status: parseFilterArrayFromQuery(routeQuery, 'status'),
    city: parseFilterArrayFromQuery(routeQuery, 'city'),
    tags: parseFilterArrayFromQuery(routeQuery, 'tags'),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}

/**
 * Mirrors getProjects params.
 */
export function buildProjectListNavigationParams(routeQuery) {
  const options = parseTableOptionsFromQuery(routeQuery, tableDefaults())
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('takenAssignees', 'taken_assignees')
      .replace('positionAmount', 'position_amount')
      .replace('demandCounter', 'demand_counter')
      .replace('clientRegistrationName', 'client__registration_name')
      .replace('clientName', 'client__name')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    ...listNavigationFlag,
    status: parseFilterArrayFromQuery(routeQuery, 'status'),
    client: parseFilterArrayFromQuery(routeQuery, 'client'),
    tags: parseFilterArrayFromQuery(routeQuery, 'tags'),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}

/**
 * Mirrors getCandidateEntries params.
 */
export function buildCandidatesListNavigationParams(routeQuery) {
  const options = parseTableOptionsFromQuery(routeQuery, tableDefaults())
  const ordering = options.sortBy.map((el, index) => {
    const parsedEl = el
      .replaceAll('.', '__')
      .replace('validUntil', 'valid_until')
      .replace('gdprStatus', 'gdpr_status')
      .replace('name', 'candidate__user__last_name')
      .replace('email', 'candidate__user__email')

    return `${options.sortDesc[index] ? '-' : ''}${parsedEl}`
  })

  return {
    ...listNavigationFlag,
    candidate__tags: parseFilterArrayFromQuery(routeQuery, 'tags'),
    gdpr_status: parseFilterArrayFromQuery(routeQuery, 'gdprStatus'),
    search: parseSearchFromQuery(routeQuery),
    ordering,
  }
}
